import Card from "@pathwright/ui/src/components/card/Card"
import MemberList from "./MemberList"
import MemberListHeader from "./MemberListHeader"

const MemberListCard = (props) => {
  const { card } = props

  React.useEffect(() => {
    // on unmount, clear the members cached so that next time the MemberList mounts, we'll query the DB afresh
    return window.App.getStore("member").action.clearMembers
  }, [])

  return (
    <Card card={card} navless style={{ paddingBottom: 0 }}>
      <div className="MemberListCard">
        <MemberListHeader onClose={card.onClose} />
        <MemberList />
      </div>
    </Card>
  )
}

MemberListCard.displayName = "MemberListCard"

export default MemberListCard
